import {React} from 'common'
import {Page} from 'components/Page'
import DanceList from 'components/Dance/DanceList'
import useMain from 'logic/Main/useMain.js'

const Main = () => {
    const {title, dances, isLoading} = useMain()

    return (
        <Page title={title} isSearchLoading={isLoading}>
            <DanceList dances={dances} height={450} />
        </Page>
    )
}

export default Main
